<template>
  <div 
    class="ll-tab-content"
    :class="{'borderTop':borderTopActive}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlTabContent",
  props:{
    borderTopActive: {
      type: Boolean,
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-tab-content";
</style>